export default __webpack_public_path__ + "static/media/vital_gatito.500ca991.jpg";